import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../Slider.styles';

var Slide = function Slide(_ref) {
  var children = _ref.children,
      slidingFromDirection = _ref.slidingFromDirection,
      transitionSpeed = _ref.transitionSpeed,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      _ref$wasActive = _ref.wasActive,
      wasActive = _ref$wasActive === void 0 ? false : _ref$wasActive,
      slideClass = _ref.slideClass;
  var slideAwayToDirection = slidingFromDirection === 'right' ? 'left' : 'right';
  return /*#__PURE__*/React.createElement(Styled.Slide, {
    slidingFromDirection: slidingFromDirection,
    slideAwayToDirection: slideAwayToDirection,
    transitionSpeed: transitionSpeed,
    previouslyActive: wasActive,
    active: isActive,
    className: slideClass
  }, children);
};

Slide.displayName = 'Slide';
Slide.propTypes = {
  slideClass: PropTypes.string,
  isActive: PropTypes.bool
};
export default Slide;